import { render, staticRenderFns } from "./PortalRadio.vue?vue&type=template&id=a014c45c&scoped=true&"
import script from "./PortalRadio.vue?vue&type=script&lang=ts&"
export * from "./PortalRadio.vue?vue&type=script&lang=ts&"
import style0 from "./PortalRadio.vue?vue&type=style&index=0&id=a014c45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a014c45c",
  null
  
)

export default component.exports